import { render, staticRenderFns } from "./EyeScholar.vue?vue&type=template&id=2be47ac2&scoped=true&"
import script from "./EyeScholar.vue?vue&type=script&lang=js&"
export * from "./EyeScholar.vue?vue&type=script&lang=js&"
import style0 from "./EyeScholar.vue?vue&type=style&index=0&id=2be47ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be47ac2",
  null
  
)

export default component.exports